export default {
    settings: false,
    communication: false,
    sourceCode: false,
    online: false,
    help: false,
    toggledSidebar: false,
    appVersion: '11-02-2019 16:00',
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/state.js